import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { registerPhoneNumber } from "../../../redux/action/auth";
import { ClipLoader } from "react-spinners";
import { Link, useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { notifyError } from "../../../helpers/helpers";

function PhoneNumberRegister() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLaptop = useMediaQuery({ query: "(max-width: 1400px)" });
  const { loading } = useSelector((state) => state.loading);
  const [phoneNumber, setPhoneNumber] = useState("");

  const handleNumberResgister = (e) => {
    e.preventDefault();
    if (phoneNumber.length < 10) return notifyError("Invalid Phone Number");
    dispatch(registerPhoneNumber({ phoneNumber: phoneNumber }, navigate));
  };

  return (
    <div className="auth-from slide-in" style={{ width: isLaptop && "700px" }}>
      <div>
        <div className="flex justify-center ">
          <img
            src="/images/auction-image.png"
            alt="logo"
            className="auction-logo"
          />
        </div>

        <h4 className="margin-0px text-center">Sign Up To Auction System</h4>
        <div className="purple lighten-5 cercle-purple-text p-1 flex mt-1">
          <i className="material-symbols-outlined">info</i>

          <p className="ml-1">
            This is a private access only. This dashboard is only for{" "}
            <b>Authorized Accounts</b>. Anyone interested in participating in
            the auction is welcome to sign up.
          </p>
        </div>

        <div className="mt-1">
          <form className="mt-1 " onSubmit={handleNumberResgister}>
            <PhoneInput
              country={"in"}
              value={phoneNumber}
              onChange={(phone) => setPhoneNumber(phone)}
              inputProps={{
                name: "phone",
                required: true,
                autoFocus: true,
              }}
              inputClass="phone-input-style width-88"
              buttonClass="pphone-input-button-style"
            />

            <div className="submit-btn mv-2 column flex align-center ">
              <button
                className="btn full-width mb-1 mt-1 "
                type="submit"
                disabled={!phoneNumber || loading}
              >
                {loading ? <ClipLoader color="#fff" size={20} /> : "Next"}
              </button>
            </div>
          </form>
        </div>

        <div className="">
          <p className="semi-bold">
            Already a member?
            <Link to={"/login"}>
              <span className="primary pointer"> Log In</span>
            </Link>{" "}
          </p>
        </div>
      </div>
    </div>
  );
}

export default PhoneNumberRegister;
